export default __webpack_public_path__ + "static/media/scale.fa6bfa77.svg";